import { CheckCircleIcon } from "@heroicons/react/24/solid";

const SubmitHookFormTS = ({
  buttonText = "Save",
  type = "submit",
  className,
  disabled = false,
  onClick,
}: {
  buttonText: string,
  type: "submit" | "button" | "reset" | undefined,
  className?: string
  disabled?: boolean,
  onClick?: () => void
}) => {
  return (
    <button
      disabled={disabled}
      type={type}
      onClick={onClick}
      className={`hover:scale-90 transition duration-500 flex items-center shadow-md text-xs 
      font-semibold text-white justify-center gap-x-1 rounded-full ml-auto bg-senary px-3 
      py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary 
      focus:ring-opacity-70 ${className}
      ${disabled && "cursor-not-allowed opacity-50"}`}
    >
      <CheckCircleIcon className="h-4 w-4" />

      <div className="-mt-auto">{buttonText}</div>
    </button>
  );
};
export default SubmitHookFormTS;
